import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { showSnackbar } from 'actions';
import * as userSelector from 'selectors/user';
import Api from 'api';
import PATHS from 'constants/paths';
import ChangePasswordComponent from '../components/change-password';

class ChangePassword extends React.Component {
  onSubmit = async (values) => {
    try {
      const { password_confirm, ...rest } = values;
      await Api.changePassword(rest);

      this.props.showSnackbar({
        severity: 'success',
        message: {
          id: 'changepwd.success',
          defaultMessage: 'The password has been changed',
        },
      });
      this.props.history.push(PATHS.users.profile);
    } catch (err) {
      this.props.showSnackbar({
        severity: 'error',
        message: {
          id: 'changepwd.error',
          defaultMessage: 'The password could not be changed: {error}',
          values: {
            error: this.props.intl.formatMessage({
              id: err.data.message,
              defaultMessage: err.data.message,
            }),
          },
        },
      });
    }
  };

  render() {
    return (
      <>
        <ChangePasswordComponent intl={this.props.intl} onSubmit={this.onSubmit} />
      </>
    );
  }
}

ChangePassword.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func }),
  data: PropTypes.shape({}),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
  showSnackbar: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: userSelector.userData(state),
});

const mapDispatchToProp = (dispatch) => ({
  showSnackbar: (config) => dispatch(showSnackbar(config)),
});

export default connect(mapStateToProps, mapDispatchToProp)(injectIntl(ChangePassword));
